import { useState } from "react";
import "./footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const [buttonText, setButtonText] = useState("Subscribe");

  const handleNewsletter = (e) => {
    e.preventDefault();

    const email = e.target.email.value;

    if (email && email.includes("@")) {
      setButtonText("✓ Done!");
      e.target.email.value = "";

      setTimeout(() => {
        setButtonText("Subscribe");
      }, 2000);
    } else {
      alert("Please enter a valid email");
    }
  };

  return (
    <footer className="main-footer">
      <div className="container">

        {/* Footer Content */}
        <div className="footer-content">

          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <i className="fas fa-gavel"></i>
              Ask <span>Jeeves IP</span>
            </div>

            <p className="footer-text">
              AI-powered patent solutions combining efficiency with expert legal
              strategy for innovators worldwide.
            </p>

            <div className="footer-badge">
              <i className="fas fa-robot"></i>
              <span>Patented Technology</span>
            </div>
          </div>

          {/* Company Links */}
          <div className="footer-links">
            <h4>Company</h4>

            <ul>
              <li><Link to={"/"}><i className="fas fa-chevron-right"></i> Home</Link></li>
              <li><Link to={"/about"}><i className="fas fa-chevron-right"></i> About</Link></li>
              <li><Link to={"/press"}><i className="fas fa-newspaper"></i> Press</Link></li>
              <li><Link to={"/services"} ><i className="fas fa-chevron-right"></i> Services</Link></li>
              <li><Link to={"/patents"}><i className="fas fa-chevron-right"></i> Patents</Link></li>
              <li><Link to={"/sms"}><i className="fas fa-comment-sms"></i> SMS</Link></li>
              <li><Link to={"/feature"}><i className="fas fa-star"></i> Features</Link></li>
              <li><Link to={"/blog"}><i className="fas fa-blog"></i> Blog</Link></li>
              <li><Link to={"/contact"}><i className="fas fa-chevron-right"></i> Contact</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-links">
            <h4>Resources</h4>

            <ul>
              {/* <li><a href="/leadership"><i className="fas fa-chevron-right"></i> Leadership</a></li> */}
              <li><Link to="/leadership"><i className="fas fa-chevron-right"></i> Leadership</Link></li>
              <li><Link to="/history"><i className="fas fa-chevron-right"></i> History</Link></li>
              <li><Link to={"/case"}><i className="fas fa-chevron-right"></i> Case Studies</Link></li>
              <Link to={"/faqs"}><i className="fas fa-chevron-right"></i> FAQs</Link>
              <li><Link to={"/terms"} ><i className="fas fa-chevron-right"></i> Terms & Conditions</Link></li>
              <li><Link to={"/privacy"} ><i className="fas fa-chevron-right"></i> Privacy Policy</Link></li>
              <li><Link to={"/marketing"}><i className="fas fa-chevron-right"></i> Marketing Policy</Link></li>
              <li><Link to={"/eula"} ><i className="fas fa-chevron-right"></i> EULA</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-links">
            <h4>Contact</h4>

            <ul className="footer-contact">
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@ask-jeevesip.com">info@ask-jeevesip.com</a>
              </li>

              {/* <li>
                <i className="fas fa-phone"></i>
                <a href="tel:+12125551278">+1 (212) 555-1278</a>
              </li> */}

              <li>
                <i className="fas fa-map-marker-alt"></i>
                <span>Parker, CO</span>
              </li>
            </ul>

            {/* Newsletter */}
            <div className="footer-newsletter">
              <p>Get IP insights</p>

              <form className="newsletter-form" onSubmit={handleNewsletter}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email address"
                  required
                />

                <button type="submit">
                  {buttonText}
                </button>
              </form>
            </div>
          </div>

        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">

          <div className="copyright">
            © 2026 Ask Jeeves IP. All rights reserved.
          </div>

          <div className="social-links">
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-facebook-f"></i></a>
          </div>

          <div className="legal-links">
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <a href="#">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;